import { render, staticRenderFns } from "./AssignedDocuments.vue?vue&type=template&id=672b9825"
import script from "./AssignedDocuments.vue?vue&type=script&lang=ts"
export * from "./AssignedDocuments.vue?vue&type=script&lang=ts"
import style0 from "./AssignedDocuments.vue?vue&type=style&index=0&id=672b9825&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports